module.exports = "/_next/static/videos/teaser1-slice-2-bc28c50ac74fb61e35a41f44ea4b3ba2.mp4";